<template>
  <div class="card_box">
    <Card>
      <div slot="title" class="titlebox">
        <span class="title">{{ $t("label.AcceptanceSearch.AcceptanceApplication") }}</span>
        <Icon type="ios-create-outline" class="applyicon" />
      </div>
      <!-- 主表内容 -->
      <Form ref="formdata" :model="formdata" :rules="rules">
        <table class="form-table form-table-print">
          <!-- 基本信息 -->
          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceNo") }}</th>
            <td>
              <Form-item prop="acceptanceId">
                <Input type="text" v-model="formdata.acceptanceId" readonly disabled />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceID") }}</th>
            <td>
              <Form-item prop="applicantUserId">
                <Input type="text" v-model="formdata.applicantUserId" disabled />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptorName") }}</th>
            <td>
              <Form-item prop="applicantUserName">
                <Input type="text" v-model="formdata.applicantUserName" disabled />
              </Form-item>
            </td>
          </tr>
          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.SupplierName") }}</th>
            <td>
              <Form-item prop="vendorName">
                <Input type="text" v-model="formdata.vendorName" disabled />
              </Form-item>
            </td>

            <th class="requiredIitm">
              {{ $t("label.Acceptance.AcceptanceMaterials") }}
               <Tooltip
                placement="left-start"
                :transfer="true"
                :maxWidth="480"
                :content="$t('label.Acceptance.Tips.Matter') +'\n' +$t('label.Acceptance.Tips.Services')"
              >
                <Icon type="ios-help-circle-outline" />
              </Tooltip>
            </th>
            <td>
               <ab-upload
                v-model="formdata.acceptanceFile"
                abPermission="w"
                 disabled
                 
               ></ab-upload>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.Note") }}</th>
            <td>
              <Form-item prop="note">
                <Input type="text" v-model="formdata.note" disabled />
              </Form-item>
            </td>
          </tr>
          <tr>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceDept") }}</th>
            <td>
              <Form-item prop="applyDepartment">
                <Input type="text" v-model="formdata.applyDepartmentName" disabled />
              </Form-item>
            </td>
            <th class="requiredIitm">{{ $t("label.Acceptance.AcceptanceDate") }}</th>
            <td>
              <Form-item >
                <Input type="text" v-model="formdata.applyData" disabled />
              </Form-item>
            </td>
          </tr>
          <tr>
                <!-- 案件名 -->
              <th class="requiredIitm">
               <span>{{ $t("label.Acceptance.caseName") }}</span>
              </th>
              <td colspan="6">
                <Form-item prop="caseName">
                  <Input type="text"
                  disabled
                   v-model="formdata.caseName" />
                </Form-item>
              </td>
              </tr>
        </table>
      </Form>
      <!-- 明细表格部分 -->
      <Form ref="listForm" :rules="rule" :model="tableObj" class="form-table-th-margin">
        <Table style="margin-top: 15px" border :columns="columns" :data="tableObj.list">
          <!-- 品目 -->
          <template slot-scope="{ row, index }" slot="itemEntrustmentName">
            <FormItem :prop="`list.${index}.itemEntrustmentName`" :rules="rule.itemEntrustmentName">
              <Input type="text" v-model="tableObj.list[index].itemEntrustmentName" disabled />
            </FormItem>
          </template>
          <!-- 供应商名称 -->
          <!-- <template slot-scope="{ row, index }" slot="vendorName">
            <FormItem :prop="`list.${index}.vendorName`" :rules="rule.vendorName">
              <Input type="text" v-model="tableObj.list[index].vendorName" disabled />
            </FormItem>
          </template> -->
          <!-- 验收总金额 -->
          <!-- <template slot-scope="{ row, index }" slot="acceptanceTotAmount">
            <FormItem :prop="`list.${index}.acceptanceTotAmount`" :rules="rule.acceptanceTotAmount">
              <InputNumber
                disabled
                :active-change="false"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width:100%;"
                :min="0"
                @on-change="numberchange($event,item.swgysList[row._index],0)"
                v-model="tableObj.list[index].acceptanceTotAmount"
              ></InputNumber>
            </FormItem>
          </template> -->
          <!-- 验收金额 -->
          <template slot-scope="{ row, index }" slot="acceptanceAmount">
            <FormItem :prop="`list.${index}.acceptanceAmount`" :rules="rule.acceptanceAmount">
              <InputNumber
                disabled
                :active-change="false"
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\s?|(,*)/g, '')"
                :precision="2"
                style="width:100%;"
                :min="0"
                @on-change="numberchange($event,item.swgysList[row._index],0)"
                v-model="tableObj.list[index].acceptanceAmount"
                :onkeyup="calculatePrice(tableObj.list[index])"
              ></InputNumber>
            </FormItem>
          </template>
          <!-- 备注 -->
          <template slot-scope="{ row, index }" slot="note">
            <FormItem :prop="`list.${index}.note`" >
              <Input type="text" v-model="tableObj.list[index].note" disabled />
            </FormItem>
          </template>
          <!-- 验收材料证明 -->
          <!-- <template slot-scope="{ row, index }" slot="acceptanceFile">
            <ab-upload v-model="tableObj.list[index].acceptanceFile" abPermission="w" disabled></ab-upload>
          </template> -->

          <!-- 规格 -->
          <template slot-scope="{ row, index }" slot="specifications" >
            <FormItem
              :prop="`list.${index}.specifications`"
            >
              <Input
                disabled
                type="text"
                v-model="tableObj.list[index].specifications"
                
              />
            </FormItem>
          </template>

          <!-- 期间 -->
          <template slot-scope="{ row, index }" slot="businessHoursEnd">
            <FormItem style="display: inline-block" 
            :prop="`list.${index}.specifications`">
              <ab-date
                disabled
                style="width: 47%;"
                v-model="tableObj.list[index].businessHoursStart"
                format="yyyy-MM-dd"
              ></ab-date>
              <span>~</span>
              <ab-date
                disabled
                style="width: 47%;"
                v-model="tableObj.list[index].businessHoursEnd"
                format="yyyy-MM-dd"
              ></ab-date>
            </FormItem>
            
          
          </template>

          <!-- 纳期 -->
          <template slot-scope="{ row, index }" slot="deliveryDeadline">
            <FormItem :prop="`list.${index}.deliveryDeadline`" >
              <ab-date
                disabled
                style="width: 100%"
                v-model="tableObj.list[index].deliveryDeadline"
                format="yyyy-MM-dd"
              ></ab-date>
            </FormItem>
          </template>

          <!-- 数量 -->
          <template slot-scope="{ row, index }" slot="amount">
            <FormItem :prop="`list.${index}.amount`" >
              <Input type="text" disabled v-model="tableObj.list[index].amount" />
            </FormItem>
          </template>

          <!-- 单价 -->
          <template slot-scope="{ row, index }" slot="price">
            <FormItem :prop="`list.${index}.price`" >
            <InputNumber
                disabled
                style="width: 100%"
                :min="0"
                v-model="tableObj.list[index].price"
              ></InputNumber>
            </FormItem>
          </template>
        </Table>
      </Form>
      <div v-if="tableObj.list[0].vendorId!=='0ZZ' && tableObj.list[0].vendorId!=='0S9' && tableObj.list[0].vendorId!=='0SA' && tableObj.list[0].vendorId!=='0SB' && tableObj.list[0].vendorId!=='0SC'">
        <div class="table_box" style="margin-top: 30px">
          <Form ref="formdata" :model="formdata" :rules="rules">
            <table
              class="i-iview-table form-table form-table-print form-table-print-sub table_box_content thead_height"
            >
              <!-- <thead>
              <tr class="firstRow" style="height: 35px">
                <th style="width: 200px">{{$t('label.Acceptance.Title01')}}</th>
                <th colspan="4">{{$t('label.Acceptance.Title02')}}</th>
              </tr>
              </thead>-->
              <thead>
                <tr class="firstRow" style="height: 33px">
                  <th
                    style="width: 120px;text-align: center;"
                    
                  >{{$t('label.Acceptance.Content')}}</th>
                  <th style="text-align: center" colspan="3">{{$t('label.Acceptance.Score')}}</th>
                  <th style="width: 200px;text-align: center" >{{$t('Acceptance-004')}}</th>
                </tr>
                <!-- <tr class="firstRow" style="height: 33px">
                  <th style="width: 205px;text-align: center">{{$t('label.Acceptance-Draction01')}}</th>
                  <th style="width: 205px;text-align: center">{{$t('label.Acceptance-Draction02')}}</th>
                  <th style="width: 205px;text-align: center">{{$t('label.Acceptance-Draction03')}}</th>
                </tr> -->
              </thead>
              <tbody>
                <!-- <tr class="h40">
                <td></td>
                <td colspan="3">{{$t('label.Acceptance.Score')}}</td>
                </tr>-->
                <!-- <tr>
                <td>{{$t('label.Acceptance.Content')}}</td>
                </tr>-->
                <tr>
                  <td>{{$t('label.Acceptance.Quality') + ' :'}}</td>
                  <td>
                    <Form-item prop="quality">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_1"
                        @on-change="selectNumber('20', 'select_1', 'quality')"
                      >{{$t('label.Acceptance.Quality01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>--</td>
                  <td>
                    <Form-item prop="quality">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_2"
                        @on-change="selectNumber('0', 'select_2', 'quality')"
                      >{{$t('label.Acceptance.Quality02')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 质量备注栏 -->
                  <td>
                    <Form-item prop="qualityNote">
                      <Input
                        type="text"
                        v-model="formdata.qualityNote"
                        :disabled="permission.TACCEPTANCEAPPLY.qualityNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('label.Acceptance.Delivery') + ' :'}}</td>
                  <td>
                    <Form-item prop="deliveryPeriod">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_3"
                        @on-change="
                      selectNumber('20', 'select_3', 'deliveryPeriod')
                    "
                      >{{$t('label.Acceptance.Delivery01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>--</td>
                  <td>
                    <Form-item prop="deliveryPeriod">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_4"
                        @on-change="selectNumber('0', 'select_4', 'deliveryPeriod')"
                      >{{$t('label.Acceptance.Delivery02')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 交货期备注栏 -->
                  <td>
                    <Form-item prop="deliveryNote">
                      <Input
                        type="text"
                        v-model="formdata.deliveryNote"
                        :disabled="permission.TACCEPTANCEAPPLY.deliveryNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('label.Acceptance.Service') + ' :'}}</td>
                  <td>
                    <Form-item prop="serviceConsclousness">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_5"
                        @on-change="
                      selectNumber('20', 'select_5', 'serviceConsclousness')
                    "
                      >{{$t('label.Acceptance.Service01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="serviceConsclousness">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_6"
                        @on-change="
                      selectNumber('10', 'select_6', 'serviceConsclousness')
                    "
                      >{{$t('label.Acceptance.Service02')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="serviceConsclousness">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_7"
                        @on-change="
                        selectNumber('0', 'select_7', 'serviceConsclousness')
                      "
                      >{{$t('label.Acceptance.Service03')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 服务意识备注栏 -->
                  <td>
                    <Form-item prop="serviceNote">
                      <Input
                        type="text"
                        v-model="formdata.serviceNote"
                        :disabled="permission.TACCEPTANCEAPPLY.serviceNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('label.Acceptance.Technical') + ' :'}}</td>
                  <td>
                    <Form-item prop="technicalCapability">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_8"
                        @on-change="
                      selectNumber('20', 'select_8', 'technicalCapability')
                    "
                      >{{$t('label.Acceptance.Technical01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="technicalCapability">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_9"
                        @on-change="
                      selectNumber('10', 'select_9', 'technicalCapability')
                    "
                      >{{$t('label.Acceptance.Technical02')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="technicalCapability">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_10"
                        @on-change="
                      selectNumber('0', 'select_10', 'technicalCapability')
                    "
                      >{{$t('label.Acceptance.Technical03')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 技术能力备注栏 -->
                  <td>
                    <Form-item prop="technologyNote">
                      <Input
                        type="text"
                        v-model="formdata.technologyNote"
                        :disabled="permission.TACCEPTANCEAPPLY.technologyNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('label.Acceptance.Management') + ' :'}}</td>
                  <td>
                    <Form-item prop="managementAbility">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_11"
                        @on-change="
                        selectNumber('20', 'select_11', 'managementAbility')
                      "
                      >{{$t('label.Acceptance.Management01')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="managementAbility">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_12"
                        @on-change="
                        selectNumber('10', 'select_12', 'managementAbility')
                      "
                      >{{$t('label.Acceptance.Management02')}}</Radio>
                    </Form-item>
                  </td>
                  <td>
                    <Form-item prop="managementAbility">
                      <Radio
                        :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                        v-model="select_13"
                        @on-change="
                        selectNumber('0', 'select_13', 'managementAbility')
                      "
                      >{{$t('label.Acceptance.Management03')}}</Radio>
                    </Form-item>
                  </td>
                  <!-- 管理能力备注栏 -->
                  <td>
                    <Form-item prop="AdministrationNote">
                      <Input
                        type="text"
                        v-model="formdata.AdministrationNote"
                        :disabled="permission.TACCEPTANCEAPPLY.AdministrationNote!=='w'"
                      />
                    </Form-item>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="display:flex;align-items:center;margin-top:20px;">
              <span>{{$t('label.Acceptance.Damage') + ' :'}}</span>
              <div style="display: inline-block; width: 10%">
                <Form-item prop="damageStatus">
                  <RadioGroup v-model="formdata.damageStatus" @on-change="damageStatust()">
                    <Radio
                      :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                      label="0"
                    >{{$t('label.Acceptance.Damage02')}}</Radio>
                    <Radio
                      :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                      label="1"
                    >{{$t('label.Acceptance.Damage01')}}</Radio>
                  </RadioGroup>
                </Form-item>
              </div>
              <div v-if="formdata.damageStatus === '1'" style="display: inline-block; width: 60%">
                <Form-item prop="damageStatusNote">
                  <i-input
                    :disabled="permission.TACCEPTANCEAPPLY.totalScore!=='w'"
                    v-model="formdata.damageStatusNote"
                  >​</i-input>
                </Form-item>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </Card>
  </div>
</template>
<script>
import util from '@/libs/util';
export default {
  data: function() {
    return {
      permission: {},
      damage: false,
      detail: false,

      select_1: false,
      select_2: false,

      select_3: false,
      select_4: false,

      select_5: false,
      select_6: false,
      select_7: false,

      select_8: false,
      select_9: false,
      select_10: false,

      select_11: false,
      select_12: false,
      select_13: false,

      diasabledInput: false,
      department: [],
      acceptanceAmountS: [],
      tableObj: {
        list: [
          {
            itemEntrustmentName: "",
            vendorName: "",
            //acceptanceTotAmount: "",
            itemName: "",
            acceptanceAmount: "",
            note: "",
            acceptanceFile: "",
            amount: "",
            price: "",
            specifications: "",
            businessHoursStaryt: "",
            businessHoursEnd: "",
            deliveryDeadline: ""
          }
        ]
      },
      rules: {
        applicantUserId: [
          {
            required: true,
            message: util.getmsg(this,'label.Acceptance.AcceptanceID'),
            trigger: "change"
          }
        ],
        applicantUserName: [
          {
            required: true,

            message: util.getmsg(this,'label.Acceptance.AcceptorName'),
            trigger: "change"
          }
        ],
        applyDepartment: [
          {
            required: true,
            message: util.getmsg(this,'label.Acceptance.AcceptanceDept'),
            trigger: "change"
          }
        ],
        applyData: [
          {
            required: true,
            type: "date",
            message: util.getmsg(this,'label.Acceptance.AcceptanceDate'),
            trigger: "change"
          }
        ],
        damageStatusNote: [
          {
            required: true,
            message: util.getmsg(this,'ERR.AcceptanceApply.003'),
            trigger: "change"
          }
        ],
        managementAbility: [
          {
            required: true,
            message: $t('label.Acceptance.Title03'),
            trigger: "change"
          }
        ],
        technicalCapability: [
          {
            required: true,
            message: $t('label.Acceptance.Title03'),
            trigger: "change"
          }
        ],
        serviceConsclousness: [
          {
            required: true,
            message: $t('label.Acceptance.Title03'),
            trigger: "change"
          }
        ],
        deliveryPeriod: [
          {
            required: true,
            message: $t('label.Acceptance.Title03'),
            trigger: "change"
          }
        ],
        quality: [
          {
            required: true,
            message: $t('label.Acceptance.Title03'),
            trigger: "change"
          }
        ],
        // qualityNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
        // deliveryNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
        // serviceNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
        // technologyNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ],
        // AdministrationNote: [
        //   {
        //     required: true,
        //     message: util.getmsg(this, "Acceptance-004"),
        //     trigger: "change"
        //   }
        // ]
      },
      columns: [
        {
          title: `${$t("label.Acceptance.No")}`,
          type: "index",
          width: 50,
          align: "center"
        },
        {
          title: `${$t("label.Acceptance.PhysicalService")}`,
          slot: "itemEntrustmentName",
          align: "center",
          width: 230,
          renderHeader: (h, params) => {
            return h("div", { class: "requiredIitm" }, $t("label.Acceptance.PhysicalService"));
          }
        },
        // {
        //   title: `${$t("label.Acceptance.SupplierName")}`,
        //   slot: "vendorName",
        //   align: "center",
        //   width: 350,
        //   renderHeader: (h, params) => {
        //     return h("div", { class: "requiredIitm" }, $t("label.Acceptance.SupplierName"));
        //   }
        // },
        // {
        //   title: `${$t("label.Acceptance.Total")}`,
        //   slot: "acceptanceTotAmount",
        //   align: "center",
        //   width: 300,
        //   renderHeader: (h, params) => {
        //     return h("div", { class: "requiredIitm" }, $t("label.Acceptance.Total"));
        //   }
        // },
        {
          title: `${$t("label.AcceptanceSearch.TheAcceptanceAmount")}`,
          slot: "acceptanceAmount",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h("div", { class: "requiredIitm" }, $t("label.AcceptanceSearch.TheAcceptanceAmount"));
          }
        },
         //数量
        {
          title: `${$t("label.Acceptance.amount")}`,
          slot: "amount",
          align: "center",
          width: 120,
          renderHeader: (h, params) => {
            return h("div", { class: "requiredIitm" }, $t("label.Acceptance.amount"));
          },
        },
        //单价
        {
          title: `${$t("label.Acceptance.price")}`,
          slot: "price",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h("div", {  }, $t("label.Acceptance.price"));
          },
        },
        //规格
        {
          title: `${$t("label.Acceptance.specification")}`,
          slot: "specifications",
          align: "center",
          width: 230,
          renderHeader: (h, params) => {
            return h("div", {  }, $t("label.Acceptance.specification")+$t("label.Acceptance.server"));
          },
        },
        //纳期
        {
           title: `${$t("label.Acceptance.deliveryDeadline")}`,
          slot: "deliveryDeadline",
          align: "center",
          width: 130,
          renderHeader: (h, params) => {
            return h("div", { class: "requiredIitm" }, $t("label.Acceptance.deliveryDeadline")+$t("label.Acceptance.server"));
          },
        },
        //期间
        {
          title: `${$t("label.Acceptance.period")}`,
          slot: "businessHoursEnd",
          align: "center",
          width: 330,
          renderHeader: (h, params) => {
            return h("div", { class: "requiredIitm" }, $t("label.Acceptance.period")+$t("label.Acceptance.object"));
          },
        },
        
        
      
        {
          title: `${$t("label.AcceptanceApplyDetail.Note")}`,
          slot: "note",
          align: "center",
          width: 230
        },
        // {
        //   title: `${$t("label.Acceptance.AcceptanceMaterials")}`,
        //   slot: "acceptanceFile",
        //   renderHeader: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Tooltip",
        //         {
        //           props: {
        //             placement: "left-start",
        //             maxWidth: 800,
        //             transfer: true,
        //             content:
        //               $t("label.Acceptance.Tips.Matter") +
        //               "\n" +
        //               $t("label.Acceptance.Tips.Services")
        //           }
        //         },
        //         [
        //           $t("label.Acceptance.AcceptanceMaterials"),
        //           h("Icon", {
        //             props: {
        //               type: "ios-help-circle-outline"
        //             },
        //             style: {
        //               fontSize: "18px", // 改变icon的样式
        //               color: "#fff"
        //             }
        //           })
        //         ]
        //       )
        //       // h("Icon", {
        //       //   props: {
        //       //     type: "ios-help-circle-outline"
        //       //   },
        //       //   style: {
        //       //     fontSize: "18px", // 改变icon的样式
        //       //     color: "#fff",
        //       //     marginLeft:'5px'
        //       //   }
        //       // })
        //     ]);
        //   },
        //   align: "center",
        //   width: 350
        // },
      ],
      rule: {
        itemEntrustmentName: [
          {
            required: true,
            message: util.getmsg(this,'label.Acceptance.PhysicalService'),
            trigger: "change"
          }
        ],
        vendorName: [
          {
            required: true,
            message: util.getmsg(this,'label.Acceptance.SupplierName'),
            trigger: "change"
          }
        ],
        acceptanceTotAmount: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this,'label.Acceptance.Total'),
            trigger: "change"
          }
        ],
        itemName: [
          {
            required: true,
            message:util.getmsg(this,'label.Acceptance.AmountInAcceptance'),
            trigger: "change"
          }
        ],
        acceptanceAmount: [
          {
            required: true,
            type: "number",

            message: util.getmsg(this,'label.Acceptance.TotalAmount'),
            trigger: "change"
          }
        ],
        acceptanceFile: [
          {
            required: true,
            message: util.getmsg(this,'label.Acceptance.AcceptanceMaterials'),
            trigger: "change"
          }
        ],
        price: [
          {
            required: true,
            type: "number",
            message: util.getmsg(this, "label.Acceptance.price"),
            trigger: "change",
          },
        ],
        amount: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.amount"),
            trigger: "change",
          },
        ],
        deliveryDeadLine:[
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.deliveryDeadline"),
            trigger: "change",
            
          }
        ],
        specifications: [
          {
            required: true,
            message: util.getmsg(this, "label.Acceptance.specification"),
            trigger: "change",
          },
        ],
      }
    };
  },
  props: {
    formdata: {
      //默认数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.permission = this.$parent.permission.AcceptanceApplication
    this.tableObj.list = this.formdata.TACCEPTANCEAPPLYDETAILList;
    //初始化一次评分
    if (!this.formdata.quality) {
      this.$set(this.formdata, "quality", "");
    }
    if (!this.formdata.deliveryPeriod) {
      this.$set(this.formdata, "deliveryPeriod", "");
    }
    if (!this.formdata.serviceConsclousness) {
      this.$set(this.formdata, "serviceConsclousness", "");
    }
    if (!this.formdata.technicalCapability) {
      this.$set(this.formdata, "technicalCapability", "");
    }
    if (!this.formdata.managementAbility) {
      this.$set(this.formdata, "managementAbility", "");
    }
    if (!this.formdata.totalScore) {
      this.$set(this.formdata, "totalScore", "0");
    }

    this.detail = !this.$parent.instance
      ? false
      : this.$parent.instance.status === "end" ||
        this.$parent.instance.status === "running"
      ? true
      : this.$parent.instance.status === "draft"
      ? false
      : false ||
        this.$parent.flowRequestParam.extendConf ||
        this.$parent.flowRequestParam.extendConf.nodeId
      ? true
      : false;
    // 详情禁用 赋值
    this.select_1 = this.formdata.quality === "20" ? true : false;
    this.select_2 = this.formdata.quality === "0" ? true : false;

    this.select_3 = this.formdata.deliveryPeriod === "20" ? true : false;
    this.select_4 = this.formdata.deliveryPeriod === "0" ? true : false;

    this.select_5 = this.formdata.serviceConsclousness === "20" ? true : false;
    this.select_6 = this.formdata.serviceConsclousness === "10" ? true : false;
    this.select_7 = this.formdata.serviceConsclousness === "0" ? true : false;

    this.select_8 = this.formdata.technicalCapability === "20" ? true : false;
    this.select_9 = this.formdata.technicalCapability === "10" ? true : false;
    this.select_10 = this.formdata.technicalCapability === "0" ? true : false;

    this.select_11 = this.formdata.managementAbility === "20" ? true : false;
    this.select_12 = this.formdata.managementAbility === "10" ? true : false;
    this.select_13 = this.formdata.managementAbility === "0" ? true : false;
    if(!this.formdata.damageStatus){
      this.$set(
        this.formdata,
        "damageStatus",
        "0"
      );
    }
  },
  methods: {
    //计算单价
    calculatePrice(value){
        
      var z=value.acceptanceAmount/value.amount

          //保留2为小数
          var f = Math.round(z*100)/100;  
          var s = f.toString();       
          var rs = s.indexOf('.');      
          if (rs < 0) {   
          rs = s.length;      
           s += '.';   
            }       
            while (s.length <= rs + 2) {   
 s += '0';       
          }
          if(value.amount=="" || value.acceptanceAmount=="" || value.amount==null){
            value.price=""
          }else{
            if(!isNaN(value.amount)){
                value.price=s
            }else{
              value.amount=""
              value.price=""
            }
          
          }
    },
    //纳期校验
     changeDate2(rule,value,callback){
        if(!value){
          callback(util.getmsg(this, "label.Acceptance.deliveryDeadline"));
        }else{
           callback();
        }
    },
    //表单提交
    // formdata
    // formDynamic
    // formService
    handleSubmit() {
      let validateflg = false;
      let flg = 0;
      this.$refs.formdata.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      this.$refs.listForm.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      if (flg === 2) {
        this.$parent.data.AcceptanceApplication.TACCEPTANCEAPPLYDETAILList = this.tableObj.list;
        validateflg = true;
      } else {
        this.errmsg();
      }
      return validateflg;
    },
    //期间校验(判断是否为空,判断期间开始时间与期间结束时间大小)
    changeDate(rule,value1,value2,callback,row){
      var start = this.moment(value1)
        .format("YYYY-MM-DD")
        .replace(/-/g, "");
      var end = this.moment(value2)
        ? this.moment(value2)
            .format("YYYY-MM-DD")
            .replace(/-/g, "")
        : 999999999999999;
      if (!value1||!value2) {
        callback(util.getmsg(this, "期间"));
      } else if (start > end) {
        callback($t("期間開始時間は期間終了時間より大きくしてはいけません。"));
      } else {
        callback();
      }
        
    },
    //公用校验
    errmsg() {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        errMsg.forEach(val => {
          this.$Message.error(val);
        });
      });
    },
    selectNumber(e, type, key) {
      this.$set(this.formdata, key, e);
      if (type === "select_1") {
        this.select_2 = false;
      }
      if (type === "select_2") {
        this.select_1 = false;
      }

      if (type === "select_3") {
        this.select_4 = false;
      }
      if (type === "select_4") {
        this.select_3 = false;
      }

      if (type === "select_5") {
        this.select_6 = false;
        this.select_7 = false;
      }
      if (type === "select_6") {
        this.select_5 = false;
        this.select_7 = false;
      }
      if (type === "select_7") {
        this.select_5 = false;
        this.select_6 = false;
      }

      if (type === "select_8") {
        this.select_9 = false;
        this.select_10 = false;
      }
      if (type === "select_9") {
        this.select_8 = false;
        this.select_10 = false;
      }
      if (type === "select_10") {
        this.select_8 = false;
        this.select_9 = false;
      }

      if (type === "select_11") {
        this.select_12 = false;
        this.select_13 = false;
      }
      if (type === "select_12") {
        this.select_11 = false;
        this.select_13 = false;
      }
      if (type === "select_13") {
        this.select_11 = false;
        this.select_12 = false;
      }

      var count =
        parseInt(this.formdata.quality === "" ? 0 : this.formdata.quality) +
        parseInt(
          this.formdata.deliveryPeriod === "" ? 0 : this.formdata.deliveryPeriod
        ) +
        parseInt(
          this.formdata.serviceConsclousness === ""
            ? 0
            : this.formdata.serviceConsclousness
        ) +
        parseInt(
          this.formdata.technicalCapability === ""
            ? 0
            : this.formdata.technicalCapability
        ) +
        parseInt(
          this.formdata.managementAbility === ""
            ? 0
            : this.formdata.managementAbility
        );
      this.$set(this.formdata, "totalScore", count.toString());
    },
    damageStatust() {
      if (this.formdata.damageStatus === "1") {
        this.damage = true;
      } else {
        this.damage = false;
        this.formdata.damageStatusNote="";
      }
    }
  }
};
</script>
<style scoped>
body .form-table tr {
  height: 40px;
}
</style>
